"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var query_1 = require('./query');
var axios = require('axios');
var SEARCH = '/search';
var REFINEMENTS = '/refinements';
var INVALID_QUERY_ERROR = 'query was not of a recognised type';
exports.DEFAULT_CONFIG = {
    timeout: 1500
};
var AbstractBridge = (function () {
    function AbstractBridge(config) {
        this.headers = {};
        this.config = Object.assign({}, exports.DEFAULT_CONFIG, config);
    }
    AbstractBridge.prototype.search = function (query, callback) {
        var _this = this;
        var _a = this.extractRequest(query), request = _a.request, queryParams = _a.queryParams;
        if (request === null)
            return this.generateError(INVALID_QUERY_ERROR, callback);
        var response = this.fireRequest(this.bridgeUrl, request, queryParams)
            .then(function (res) { return res.records ? Object.assign(res, { records: res.records.map(_this.convertRecordFields) }) : res; });
        return this.handleResponse(response, callback);
    };
    AbstractBridge.prototype.refinements = function (query, navigationName, callback) {
        var request = this.extractRequest(query).request;
        if (request === null)
            return this.generateError(INVALID_QUERY_ERROR, callback);
        var refinementsRequest = { originalQuery: request, navigationName: navigationName };
        var response = this.fireRequest(this.refinementsUrl, refinementsRequest);
        return this.handleResponse(response, callback);
    };
    AbstractBridge.prototype.handleResponse = function (response, callback) {
        if (callback) {
            response.then(function (res) { return callback(undefined, res); }, function (err) { return callback(err); });
        }
        else {
            return response;
        }
    };
    AbstractBridge.prototype.extractRequest = function (query) {
        switch (typeof query) {
            case 'string': return { request: new query_1.Query(query).build(), queryParams: {} };
            case 'object': return query instanceof query_1.Query
                ? { request: query.build(), queryParams: query.queryParams }
                : { request: query, queryParams: {} };
            default: return { request: null, queryParams: null };
        }
    };
    AbstractBridge.prototype.generateError = function (error, callback) {
        var err = new Error(error);
        if (callback) {
            callback(err);
        }
        else {
            return Promise.reject(err);
        }
    };
    AbstractBridge.prototype.fireRequest = function (url, body, queryParams) {
        var _this = this;
        if (queryParams === void 0) { queryParams = {}; }
        var options = {
            url: url,
            method: 'post',
            params: queryParams,
            data: this.augmentRequest(body),
            headers: this.headers,
            responseType: 'json',
            timeout: this.config.timeout
        };
        return axios(options)
            .then(function (res) { return res.data; })
            .catch(function (err) {
            if (_this.errorHandler) {
                _this.errorHandler(err);
            }
            throw err;
        });
    };
    AbstractBridge.prototype.convertRecordFields = function (record) {
        var converted = Object.assign(record, { id: record._id, url: record._u, title: record._t });
        delete converted._id;
        delete converted._u;
        delete converted._t;
        if (record._snippet) {
            converted.snippet = record._snippet;
            delete converted._snippet;
        }
        return converted;
    };
    return AbstractBridge;
}());
exports.AbstractBridge = AbstractBridge;
var CloudBridge = (function (_super) {
    __extends(CloudBridge, _super);
    function CloudBridge(clientKey, customerId, config) {
        if (config === void 0) { config = {}; }
        _super.call(this, config);
        this.clientKey = clientKey;
        this.baseUrl = "https://" + customerId + ".groupbycloud.com:443/api/v1";
        this.bridgeUrl = this.baseUrl + SEARCH;
        this.refinementsUrl = this.bridgeUrl + REFINEMENTS;
    }
    CloudBridge.prototype.augmentRequest = function (request) {
        return Object.assign(request, { clientKey: this.clientKey });
    };
    return CloudBridge;
}(AbstractBridge));
exports.CloudBridge = CloudBridge;
var BrowserBridge = (function (_super) {
    __extends(BrowserBridge, _super);
    function BrowserBridge(customerId, https, config) {
        if (https === void 0) { https = false; }
        if (config === void 0) { config = {}; }
        _super.call(this, config);
        var scheme = https ? 'https' : 'http';
        var port = https ? ':443' : '';
        this.baseUrl = scheme + "://" + customerId + "-cors.groupbycloud.com" + port + "/api/v1";
        this.bridgeUrl = this.baseUrl + SEARCH;
        this.refinementsUrl = this.bridgeUrl + REFINEMENTS;
    }
    BrowserBridge.prototype.augmentRequest = function (request) {
        return request;
    };
    return BrowserBridge;
}(AbstractBridge));
exports.BrowserBridge = BrowserBridge;



//////////////////
// WEBPACK FOOTER
// ./~/groupby-api/dist/src/core/bridge.js
// module id = 143
// module chunks = 0